




































































































































































































	import { Component, Vue, Watch, Prop, Model } from 'vue-property-decorator';

	/**
	 * Helpers
	 */
	import { getFullName } from "@/utils/users-helpers";
	import { getDateString, sortByDate } from "@/utils/date-helpers";

	/**
	 * Mixins
	 */
	import mixinsBooking from '@/mixins/booking-mixins';

	/**
	 * API
	 */


	/**
	 * Components
	 */
	import CalendarPicker from '@/components/_global/CalendarPicker.vue';

	/**
	 * Types
	 */
	import { FilterModel } from "@/components/_global/FilterControl.vue";
	import { BookingState } from '@/api/bookings';

	/**
	 * Composant de lecture et réservation commun au passage et au click & collect.
	 */
	@Component({
		components: {
			'app-calendar-picker': CalendarPicker
		},
		mixins: [mixinsBooking]
	})
	export default class BookingCalendar extends Vue {
		/** Injections */
		bookingState = BookingState;
		getFullName = getFullName;

		/** Constantes */
		SYMBOL_BOOKING_CONFIRMED = '&#9632;';
		SYMBOL_BOOKING_WAITING = '&#9633;';
		COLOR_BOOKING = 'green';

		SYMBOL_MULTIPLE_EVENTS = '&#8230;';
		COLOR_MULTIPLE_EVENTS = 'black';

		/** Propriétés */
		@Prop()
		fetchMonthScheduledEntries!: (month: number, year: number) => any[];
		@Prop()
		fetchMonthBookableDates!: (month: number, year: number) => any[];
		@Prop()
		fetchMonthBookings!: (month: number, year: number) => any[];

		@Prop()
		onMoreClick!: (booking: any) => void;

		@Prop()
		users!: any[];

		@Prop()
		services!: any[];

		@Prop({ default: false })
		isLoading!: boolean;
		@Prop({ default: false })
		isActionLoading!: boolean;

		@Prop({ default: 10000 })
		automaticRefreshPeriodInMS!: number;

		@Prop({ default: false })
		enableModifications!: boolean;

		/** Attributs */
		legend = [{
			label: 'booking.booking_confirmed',
			symbol: this.SYMBOL_BOOKING_CONFIRMED,
			color: this.COLOR_BOOKING,
			isDisplayed: () => this.displayedBookings().filter(b => b.state === BookingState.CONFIRMED).length > 0
		}, {
			label: 'booking.booking_waiting',
			symbol: this.SYMBOL_BOOKING_WAITING,
			color: this.COLOR_BOOKING,
			isDisplayed: () => this.displayedBookings().filter(b => b.state !== BookingState.CONFIRMED).length > 0
		}];

		isMonthChangedLoading = false;

		filterModel: FilterModel | null = null;

		// La date courante sélectionnée
		date: string | null = null;

		// Le mois courant
		month: string | null = null;

		// Les dates du mois réservables
		monthBookableDates: any[] = [];
		// Les dates du mois prévues
		monthScheduledEntries: any[] = [];
		// Les réservations/déréservations du mois
		monthBookings: any[] = [];

		polling: any = null;

		// Les dates autorisées à être sélectionnées
		allowedDates = (val: string) => {
			return this.canBookOnDate(val) || this.functionEvents(val).length > 0;
		}

		/**
		 * Les réservations du jour sélectionné.
		 */
		get currentDateBookings(): any[] {
			return this.displayedBookings()
				.filter((x) => getDateString(new Date(x.bookedDate)) === this.date)
				.sort((a, b) => sortByDate(new Date(a.bookedDate), new Date(b.bookedDate)));
		}

		/**
		 * Les prévisions du jour sélectionné.
		 */
		get currentDateScheduledEntries(): any[] {
			return this.displayedScheduledEntries()
				.filter((x) => getDateString(new Date(x.date)) === this.date)
				.sort((a, b) => sortByDate(new Date(a.date), new Date(b.date)));
		}

		/**
		 * Peut-on réserver le jour sélectionné.
		 */
		get canBook() {

			// test des limites de service
			var isokForService = false;
			if (this.filterModel != null) {
				let selectedServiceID  = this.filterModel.selection.SERVICE;
				if (selectedServiceID != null && this.date != null) {
					var dateDePassage = new Date(this.date + " 00:00:00");
					const myService = this.services.find((x) => x.id === selectedServiceID  )
					if (myService != null) {
						const dateServiceAPartir = new Date(myService.resaLockedDate)
						// test du jour à partir duquel on peut réserver (blocage des réservations par la cuisine)
						isokForService = (dateServiceAPartir < dateDePassage);
                        // test du jour jusqu'auquel on peut réserver 
						if (isokForService && myService.resaUntilDate > 0) {
							const dLimit = new Date(new Date().toDateString());
							dLimit.setDate(dLimit.getDate() + myService.resaUntilDate);
							//alert(dLimit);
                            isokForService = (dateDePassage <= dLimit)
						}
						// test du temps restant avant démarrage du service
						if (isokForService ) {
							const servicestartTime = new Date(myService.timeStart);
                            dateDePassage.setHours(servicestartTime.getHours());
                            dateDePassage.setMinutes(servicestartTime.getMinutes());
                            var numberOfMlSeconds = dateDePassage.getTime();
                            var addMlSeconds = (myService.bookabilityThresholdInMinutes + 2 ) * 60 * 1000;
							var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
							//alert(dateDePassage);
							//alert(newDateObj);
                            //alert(new Date());
							isokForService = newDateObj > new Date();

						}

					}
				}
            }

			return this.areAllFiltersSelected() // tous les filtres sont sélectionnés
                && isokForService // les limites du service ne sont pas atteintes
				&& this.date // une date est sélectionnée
				&& this.canBookOnDate(this.date) // on peut réserver à cette date
				&& this.currentDateBookings.length === 0; // il n'y a aucune réservation à cette date


		}

		get minDate() {
			return undefined;
		}

		get maxDate() {
			return undefined;
		}

		get filtersDefinitions() {
			const fd: any = {};

			if (this.users != null && this.users.length > 1) {
				fd.USER = {
					label: this.$t('booking.user'),
					value: (x: any) => getFullName(x),
					key: 'id',
					items: this.users,
					f: (keySelected: string) => (x: any) => x.user.id === keySelected,
					placeholder: this.$t('booking.all_users')
				};
			}

			if (this.services != null && this.services.length > 1) {
				fd.SERVICE = {
					label: this.$t('booking.service'),
					value: (x: any) => x.label,
					key: 'id',
					items: this.services,
					f: (keySelected: string) => (x: any) => x.service.id === keySelected,
					placeholder: this.$t('booking.all_services')
				};
			}
			return fd;
		}

		get isUserFilterSelected() {
			return this.users == null || this.users.length === 1 || this.filterModel == null || this.filterModel.selection.USER != null;
		}
		get isServiceFilterSelected() {
			return this.services == null || this.services.length === 1 || this.filterModel == null || this.filterModel.selection.SERVICE != null;
		}

		/** Méthodes */
		async created() {
			this.pollData();
		}

		pollData() {
			const that = this;
			if (this.automaticRefreshPeriodInMS > 0) {
				this.polling = setInterval(async () => {
					await that.reloadBookings();
				}, this.automaticRefreshPeriodInMS);
			}
		}

		beforeDestroy() {
			clearInterval(this.polling);
		}

		areAllFiltersSelected() {
			if (this.filterModel == null) {
				return false;
			}
			const selection = this.filterModel.selection;
			const selectionKeys = Object.keys(selection);
			return selectionKeys.filter((k) => selection[k] != null).length === selectionKeys.length;
		}

		/**
		 * Retourne les évènements à afficher sur le calendrier à la date *date*.
		 */
		functionEvents(date: string) {
			const dateBookings = this.displayedBookings()
				.filter((x) => {
					return getDateString(new Date(x.bookedDate)) === date;
				});
			const dateScheduledEntries = this.displayedScheduledEntries()
				.filter((x) => {
					return getDateString(new Date(x.date)) === date;
				});

			const events: Array<{ color: string | undefined, character: string | undefined, background: string | undefined }> = [
				...dateBookings.map((d) => ({
					color: this.COLOR_BOOKING,
					character: d.state === BookingState.CONFIRMED ? this.SYMBOL_BOOKING_CONFIRMED : (d.state === BookingState.CANCELLED ? ' ' : this.SYMBOL_BOOKING_WAITING),
					background: undefined,
					size: '1.2em'
				})),
				...(this.areAllFiltersSelected() ? dateScheduledEntries.map((d) => ({
					color: undefined,
					character: undefined,
					background: d.isConfirmed && d.isScheduled ? 'blue lighten-5' : undefined
				})) : [])
			];
			return events.filter(e => e.character != null).length > 1 ? [{
				color: this.COLOR_MULTIPLE_EVENTS,
				character: this.SYMBOL_MULTIPLE_EVENTS,
				size: '1.5em'
			}] : events;
		}


		/**
		 * Peut-on réserver à la date *date* ?
		 */
		canBookOnDate(date: string) {
			return this.displayedBookableDates()
				.filter((x) => getDateString(new Date(x.date)) === date)
				.length > 0;
		}

		/**
		 * Callback lorsque le mois sélectionné change.
		 */
		async monthChanged(month: string) {
			this.month = month;
			this.isMonthChangedLoading = true;
			await this.reloadBookings();
			this.isMonthChangedLoading = false;
		}

		async reloadBookings() {
			const date = new Date(this.month as string);

			const month = date.getMonth() + 1;
			const year = date.getFullYear();

			const promises: any[] = [];
			promises.push(this.fetchMonthScheduledEntries ? this.fetchMonthScheduledEntries(month, year) : null);
			promises.push(this.fetchMonthBookableDates ? this.fetchMonthBookableDates(month, year) : null);
			promises.push(this.fetchMonthBookings ? this.fetchMonthBookings(month, year) : null);

			[this.monthScheduledEntries, this.monthBookableDates, this.monthBookings] = await Promise.all(promises);
		}

		/**
		 * Callback lorsque l'on clique sur "Réserver".
		 */
		async handleBookingClick() {
			const currentDate = this.date;
			if (currentDate == null || this.filterModel == null) {
				return;
			}

			let userIDSelected = this.filterModel.selection.USER;
			if (userIDSelected == null) {
				userIDSelected = this.users[0].id;
			}
			let serviceIDSelected = this.filterModel.selection.SERVICE;
			if (serviceIDSelected == null) {
				serviceIDSelected = this.services[0].id;
			}
			this.$emit('onBookClick', new Date(currentDate), userIDSelected, serviceIDSelected);
		}

		/**
		 * Callback lorsque l'on clique sur "Déréserver".
		 */
		async handleUnbookingClick(serviceID: number, userID: number) {
			const currentDate = this.date;
			if (currentDate == null) {
				return;
			}

			this.$emit('onUnbookClick', new Date(currentDate), userID, serviceID);
		}

		/**
		 * Callback lorsque l'on clique sur "Annuler" une réservation ou "Annuler" une déréservation.
		 */
		async handleCancelClick(serviceID: number, userID: number) {
			const currentDate = this.date;
			if (currentDate == null) {
				return;
			}

			const r = confirm(this.$t("booking.confirm_cancellation__").toString());
			if (!r) {
				return;
			}

			this.$emit('onCancelClick', new Date(currentDate), userID, serviceID);
		}

		/**
		 * Callback lorsque l'on clique sur "Détails" d'une réservation.
		 */
		async handleMoreClick(booking: any) {
			await this.onMoreClick(booking);
		}

		/**
		 * Les dates réservables + filtres.
		 */
		displayedBookableDates(): any[] {
			return this.monthBookableDates != null ? (this.filterModel ? this.monthBookableDates.filter(this.filterModel.predicate) : this.monthBookableDates) : [];
		}

		/**
		 * Les dates réservées + filtres.
		 */
		displayedBookings(): any[] {
			return this.monthBookings != null ? (this.filterModel ? this.monthBookings.filter(this.filterModel.predicate) : this.monthBookings) : [];
		}

		/**
		 * Les dates prévues + filtres.
		 */
		displayedScheduledEntries(): any[] {
			return this.monthScheduledEntries != null ? (this.filterModel ? this.monthScheduledEntries.filter(this.filterModel.predicate) : this.monthScheduledEntries) : [];
		}
	}
